import ErrorString from './error_string';

export default function Textarea(props)
{
    const {
        className,
        error,
        id,
        name,
        onChange,
        placeholder,
        required,
        value
    } = props

    return (
        <>
            <textarea
                className={ "block w-full bg-white border-grey-2 rounded-sm focus:border-bb focus:ring-bb" + (className ? " " + className : "") }
                id={ id }
                name={ name }
                onChange={ onChange }
                placeholder={ placeholder }
                required={ required }
                type="text"
                value={ value }
            />
            <ErrorString error={ error } />
        </>
    );
}